import Range from './Range';

const Date = Range;
Date.Range = Range;

export default Date;
